/* eslint-disable sonarjs/no-identical-functions */
// TODO(eslint): fix multiple identical functions error
import { COVERAGE_FORM, COVERAGE_NAMES } from "@platform/rfp-core";

import { DOCUMENT_NAMES } from "../../../constants/rfp";

const { SINGLE_PLAN, PLAN_TYPE } = COVERAGE_FORM;

const {
  ACCIDENT,
  VISION,
  CANCER,
  CI,
  HOSPITAL,
  WHOLE_LIFE,
  LTD,
  FMLA,
  BASIC_LIFE,
  VOLUNTARY_LIFE,
  STD,
  EAP,
  DENTAL,
  DENTAL_PPO,
  DENTAL_DHMO,
  INDIVIDUAL_DISABILITY,
  SDL,
} = COVERAGE_NAMES;

const {
  CENSUS,
  PROVIDER_UTILIZATION_REPORT,
  CURRENT_PLAN_DOCUMENT,
  RENEWAL_RATE,
  DENTALPPO,
  MPVSCE,
  LTD_CLAIMS_LISTING,
  LTD_RESERVES_EXHIBIT,
  CURRENT_RATES,
  INCIDENT_REPORT,
  WAIVER,
} = DOCUMENT_NAMES;

const LTD_CLAIMS_DOCS_MIN_LIVES = 500;

export const handleNumericFieldChange = (
  target,
  planName = SINGLE_PLAN,
  handlePlanFormChange,
) => {
  const regex = /^\d+$/;
  if (target.value == "" || regex.test(target.value)) {
    handlePlanFormChange(target, planName);
  }
};

export const mergeObject = (A, B) => {
  const res = {};
  Object.keys({ ...A, ...B }).map((key) => {
    res[key] = B[key] || A[key];
  });
  return res;
};

export const mergedErrors = (plansErrors) => {
  const total = [...plansErrors].reduce((acc, obj) => {
    delete obj?.planName;
    return mergeObject(acc, obj);
  }, {});
  return total;
};

const getEnrolledLivesValues = (plans) => {
  const fieldValues = [];
  plans?.forEach((plan) => fieldValues.push(parseInt(plan["enrolledLives"])));
  return fieldValues;
};

const isEnrolledLivesValid = (enrolledLives, limit) =>
  enrolledLives.some((item) => item >= limit);

export const getCoveragesDocuments = (isCurrentClient, coverage) => {
  const enrolledLives = getEnrolledLivesValues(coverage.details?.plans);
  const { isCurrentCoverage } = coverage;
  switch (coverage.name) {
    case DENTAL:
    case DENTAL_PPO:
    case DENTAL_DHMO:
      return getDentalDocuments(
        isCurrentClient,
        enrolledLives,
        isCurrentCoverage,
      );
    case VISION:
      return getVisionDocuments(
        isCurrentClient,
        enrolledLives,
        isCurrentCoverage,
      );
    case CI:
      return getCriticalIllnessDocuments(
        isCurrentClient,
        enrolledLives,
        isCurrentCoverage,
      );
    case ACCIDENT:
      return getAccidentDocuments(
        isCurrentClient,
        enrolledLives,
        isCurrentCoverage,
      );
    case CANCER:
      return getCancerDocuments(
        isCurrentClient,
        enrolledLives,
        isCurrentCoverage,
      );
    case HOSPITAL:
      return getHospitalDocuments(
        isCurrentClient,
        enrolledLives,
        isCurrentCoverage,
      );
    case LTD:
      return getLTDDocuments(isCurrentClient, enrolledLives, isCurrentCoverage);
    case WHOLE_LIFE:
      return getWholeLifeDocuments(
        isCurrentClient,
        enrolledLives,
        isCurrentCoverage,
      );
    case FMLA:
      return getFMLADocuments(
        isCurrentClient,
        enrolledLives,
        isCurrentCoverage,
      );
    case BASIC_LIFE:
      return getBasicLifeDocuments(
        isCurrentClient,
        enrolledLives,
        isCurrentCoverage,
      );
    case VOLUNTARY_LIFE:
      return getVoluntaryLifeDocuments(
        isCurrentClient,
        enrolledLives,
        isCurrentCoverage,
      );
    case STD:
      return getSTDDocuments(isCurrentClient, enrolledLives, isCurrentCoverage);
    case EAP:
      return getEAPDocuments(isCurrentClient, enrolledLives, isCurrentCoverage);
    case INDIVIDUAL_DISABILITY:
      return getIndividualDisabilityDocuments(
        isCurrentClient,
        enrolledLives,
        isCurrentCoverage,
      );
    case SDL:
      return getSDLDocuments(isCurrentClient, enrolledLives, isCurrentCoverage);
    default:
      return;
  }
};

const getDentalDocuments = (
  isCurrentClient,
  enrolledLives,
  isCurrentCoverage,
) =>
  isCurrentCoverage
    ? isCurrentClient
      ? [
          {
            name: CENSUS,
            required: true,
          },
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: true,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          isEnrolledLivesValid(enrolledLives, 500) && {
            name: PROVIDER_UTILIZATION_REPORT,
            required: false,
          },
          isEnrolledLivesValid(enrolledLives, 500) && {
            name: DENTALPPO,
            required: false,
          },
          isEnrolledLivesValid(enrolledLives, 100) && {
            name: MPVSCE,
            required: true,
          },
          {
            name: CURRENT_RATES,
            required: true,
          },
        ]
      : [
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: false,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          {
            name: CENSUS,
            required: true,
          },
          isEnrolledLivesValid(enrolledLives, 500) && {
            name: PROVIDER_UTILIZATION_REPORT,
            required: false,
          },
          isEnrolledLivesValid(enrolledLives, 500) && {
            name: DENTALPPO,
            required: false,
          },
          isEnrolledLivesValid(enrolledLives, 100) && {
            name: MPVSCE,
            required: true,
          },
          {
            name: CURRENT_RATES,
            required: isEnrolledLivesValid(enrolledLives, 100),
          },
        ]
    : [
        {
          name: CENSUS,
          required: true,
        },
      ];

const getVisionDocuments = (
  isCurrentClient,
  enrolledLives,
  isCurrentCoverage,
) =>
  isCurrentCoverage
    ? isCurrentClient
      ? [
          {
            name: CENSUS,
            required: true,
          },
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: true,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          isEnrolledLivesValid(enrolledLives, 500) && {
            name: MPVSCE,
            required: true,
          },
          {
            name: CURRENT_RATES,
            required: true,
          },
        ]
      : [
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: false,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          {
            name: CENSUS,
            required: true,
          },
          isEnrolledLivesValid(enrolledLives, 500) && {
            name: MPVSCE,
            required: true,
          },
          {
            name: CURRENT_RATES,
            required: isEnrolledLivesValid(enrolledLives, 500),
          },
        ]
    : [
        {
          name: CENSUS,
          required: true,
        },
      ];

const getCriticalIllnessDocuments = (
  isCurrentClient,
  enrolledLives,
  isCurrentCoverage,
) =>
  isCurrentCoverage
    ? isCurrentClient
      ? [
          {
            name: CENSUS,
            required: true,
          },
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: true,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          {
            name: CURRENT_RATES,
            required: true,
          },
        ]
      : [
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: false,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          {
            name: CENSUS,
            required: true,
          },
          {
            name: CURRENT_RATES,
            required: false,
          },
        ]
    : [
        {
          name: CENSUS,
          required: true,
        },
      ];

const getAccidentDocuments = (
  isCurrentClient,
  enrolledLives,
  isCurrentCoverage,
) =>
  isCurrentCoverage
    ? isCurrentClient
      ? [
          {
            name: CENSUS,
            required: true,
          },
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: true,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          {
            name: CURRENT_RATES,
            required: true,
          },
        ]
      : [
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: false,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          {
            name: CENSUS,
            required: true,
          },
          {
            name: CURRENT_RATES,
            required: false,
          },
        ]
    : [
        {
          name: CENSUS,
          required: true,
        },
      ];

const getCancerDocuments = (
  isCurrentClient,
  enrolledLives,
  isCurrentCoverage,
) =>
  isCurrentCoverage
    ? isCurrentClient
      ? [
          {
            name: CENSUS,
            required: true,
          },
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: true,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          {
            name: CURRENT_RATES,
            required: true,
          },
        ]
      : [
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: false,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          {
            name: CENSUS,
            required: true,
          },
          {
            name: CURRENT_RATES,
            required: false,
          },
        ]
    : [
        {
          name: CENSUS,
          required: true,
        },
      ];

const getHospitalDocuments = (
  isCurrentClient,
  enrolledLives,
  isCurrentCoverage,
) =>
  isCurrentCoverage
    ? isCurrentClient
      ? [
          {
            name: CENSUS,
            required: true,
          },
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: true,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          {
            name: CURRENT_RATES,
            required: true,
          },
        ]
      : [
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: false,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          {
            name: CENSUS,
            required: true,
          },
          {
            name: CURRENT_RATES,
            required: false,
          },
        ]
    : [
        {
          name: CENSUS,
          required: true,
        },
      ];

const getLTDDocuments = (isCurrentClient, enrolledLives, isCurrentCoverage) =>
  isCurrentCoverage
    ? isCurrentClient
      ? [
          {
            name: CENSUS,
            required: true,
          },
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: true,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          isEnrolledLivesValid(enrolledLives, LTD_CLAIMS_DOCS_MIN_LIVES) && {
            name: MPVSCE,
            required: true,
          },
          isEnrolledLivesValid(enrolledLives, LTD_CLAIMS_DOCS_MIN_LIVES) && {
            name: LTD_CLAIMS_LISTING,
            required: true,
          },
          isEnrolledLivesValid(enrolledLives, LTD_CLAIMS_DOCS_MIN_LIVES) && {
            name: LTD_RESERVES_EXHIBIT,
            required: true,
          },
          {
            name: CURRENT_RATES,
            required: true,
          },
        ]
      : [
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: false,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          {
            name: CENSUS,
            required: true,
          },
          isEnrolledLivesValid(enrolledLives, LTD_CLAIMS_DOCS_MIN_LIVES) && {
            name: MPVSCE,
            required: true,
          },
          isEnrolledLivesValid(enrolledLives, LTD_CLAIMS_DOCS_MIN_LIVES) && {
            name: LTD_CLAIMS_LISTING,
            required: true,
          },
          isEnrolledLivesValid(enrolledLives, LTD_CLAIMS_DOCS_MIN_LIVES) && {
            name: LTD_RESERVES_EXHIBIT,
            required: true,
          },
          {
            name: CURRENT_RATES,
            required: isEnrolledLivesValid(enrolledLives, 250),
          },
        ]
    : [
        {
          name: CENSUS,
          required: true,
        },
      ];

const getWholeLifeDocuments = (
  isCurrentClient,
  enrolledLives,
  isCurrentCoverage,
) =>
  isCurrentCoverage
    ? isCurrentClient
      ? [
          {
            name: CENSUS,
            required: true,
          },
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: true,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
        ]
      : [
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: false,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          {
            name: CENSUS,
            required: true,
          },
        ]
    : [
        {
          name: CENSUS,
          required: true,
        },
      ];

const getFMLADocuments = (isCurrentClient, enrolledLives, isCurrentCoverage) =>
  isCurrentCoverage
    ? isCurrentClient
      ? [
          {
            name: CENSUS,
            required: true,
          },
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: true,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          {
            name: MPVSCE,
            required: false,
          },
          {
            name: CURRENT_RATES,
            required: false,
          },
          {
            name: INCIDENT_REPORT,
            required: false,
          },
        ]
      : [
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: false,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          {
            name: CENSUS,
            required: true,
          },
          {
            name: MPVSCE,
            required: false,
          },
          {
            name: INCIDENT_REPORT,
            required: false,
          },
        ]
    : [
        {
          name: CENSUS,
          required: true,
        },
      ];

const getBasicLifeDocuments = (
  isCurrentClient,
  enrolledLives,
  isCurrentCoverage,
) =>
  isCurrentCoverage
    ? isCurrentClient
      ? [
          {
            name: CENSUS,
            required: true,
          },
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: true,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          isEnrolledLivesValid(enrolledLives, 500) && {
            name: MPVSCE,
            required: true,
          },
          {
            name: CURRENT_RATES,
            required: true,
          },
          isEnrolledLivesValid(enrolledLives, 500) && {
            name: WAIVER,
            required: true,
          },
        ]
      : [
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: false,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          {
            name: CENSUS,
            required: true,
          },
          isEnrolledLivesValid(enrolledLives, 500) && {
            name: MPVSCE,
            required: true,
          },
          {
            name: CURRENT_RATES,
            required: isEnrolledLivesValid(enrolledLives, 500),
          },
          isEnrolledLivesValid(enrolledLives, 500) && {
            name: WAIVER,
            required: true,
          },
        ]
    : [
        {
          name: CENSUS,
          required: true,
        },
      ];

const getVoluntaryLifeDocuments = (
  isCurrentClient,
  enrolledLives,
  isCurrentCoverage,
) =>
  isCurrentCoverage
    ? isCurrentClient
      ? [
          {
            name: CENSUS,
            required: true,
          },
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: true,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          isEnrolledLivesValid(enrolledLives, 500) && {
            name: MPVSCE,
            required: true,
          },
          {
            name: CURRENT_RATES,
            required: true,
          },
          isEnrolledLivesValid(enrolledLives, 500) && {
            name: WAIVER,
            required: true,
          },
        ]
      : [
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: false,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          {
            name: CENSUS,
            required: true,
          },
          isEnrolledLivesValid(enrolledLives, 500) && {
            name: MPVSCE,
            required: true,
          },
          {
            name: CURRENT_RATES,
            required: isEnrolledLivesValid(enrolledLives, 500),
          },
          isEnrolledLivesValid(enrolledLives, 500) && {
            name: WAIVER,
            required: true,
          },
        ]
    : [
        {
          name: CENSUS,
          required: true,
        },
      ];

const getSTDDocuments = (isCurrentClient, enrolledLives, isCurrentCoverage) =>
  isCurrentCoverage
    ? isCurrentClient
      ? [
          {
            name: CENSUS,
            required: true,
          },
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: true,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          isEnrolledLivesValid(enrolledLives, 100) && {
            name: MPVSCE,
            required: true,
          },
          {
            name: CURRENT_RATES,
            required: true,
          },
        ]
      : [
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: false,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          {
            name: CENSUS,
            required: true,
          },
          isEnrolledLivesValid(enrolledLives, 100) && {
            name: MPVSCE,
            required: true,
          },
          {
            name: CURRENT_RATES,
            required: isEnrolledLivesValid(enrolledLives, 100),
          },
        ]
    : [
        {
          name: CENSUS,
          required: true,
        },
      ];

const getEAPDocuments = (isCurrentClient, enrolledLives, isCurrentCoverage) =>
  isCurrentCoverage
    ? isCurrentClient
      ? [
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: false,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          {
            name: MPVSCE,
            required: false,
          },
          {
            name: CURRENT_RATES,
            required: false,
          },
        ]
      : [
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: false,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          {
            name: CURRENT_RATES,
            required: false,
          },
        ]
    : [];

const getIndividualDisabilityDocuments = (
  isCurrentClient,
  enrolledLives,
  isCurrentCoverage,
) =>
  isCurrentCoverage
    ? isCurrentClient
      ? [
          {
            name: CENSUS,
            required: true,
          },
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: true,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          {
            name: CURRENT_RATES,
            required: true,
          },
        ]
      : [
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: true,
          },
          {
            name: CENSUS,
            required: true,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          {
            name: CURRENT_RATES,
            required: true,
          },
        ]
    : [
        {
          name: CENSUS,
          required: true,
        },
      ];

const getSDLDocuments = (isCurrentClient, enrolledLives, isCurrentCoverage) =>
  isCurrentCoverage
    ? isCurrentClient
      ? [
          {
            name: CENSUS,
            required: false,
          },
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: false,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          {
            name: MPVSCE,
            required: false,
          },
          {
            name: CURRENT_RATES,
            required: false,
          },
        ]
      : [
          {
            name: CENSUS,
            required: false,
          },
          {
            name: CURRENT_PLAN_DOCUMENT,
            required: false,
          },
          {
            name: RENEWAL_RATE,
            required: false,
          },
          {
            name: MPVSCE,
            required: false,
          },
        ]
    : [
        {
          name: CENSUS,
          required: false,
        },
      ];

export const isDisabledNextStepFn = (coverage, singlePlanType, activeTab) =>
  coverage?.details[PLAN_TYPE] === singlePlanType || activeTab === 1
    ? !coverage?.isValid
    : false;
